/** 工作區顯示偏好；只儲存介面設定，不儲存文件或權限資料。 */
export function initWorkspaceUI({state, renderList, fitColumns}) {
  const shell = document.querySelector('.app-shell');
  const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch { /* 私密模式仍可操作 */ } };
  const columns = [['no','圖號'], ['folder','位置'], ['disc','專業'], ['status','文件狀態']];
  let saved = {};
  try { saved = JSON.parse(read('dcms.ui.columns') || '{}') || {}; } catch { /* 使用預設 */ }
  const preferences = {};
  const host = document.querySelector('#libraryColumns');
  for (const [key, label] of columns) {
    const visible = typeof saved[key] === 'boolean' ? saved[key] : !['folder','disc'].includes(key);
    preferences[key] = visible;
    shell.classList.toggle(`hide-col-${key}`, !visible);
    const row = document.createElement('label');
    const input = document.createElement('input');
    input.type = 'checkbox'; input.checked = visible;
    input.addEventListener('change', () => {
      preferences[key] = input.checked;
      shell.classList.toggle(`hide-col-${key}`, !input.checked);
      write('dcms.ui.columns', JSON.stringify(preferences));
      fitColumns();
    });
    row.append(input, document.createTextNode(label)); host.append(row);
  }
  const density = document.querySelector('#libraryDensity');
  density.value = read('dcms.ui.density') === 'compact' ? 'compact' : 'comfortable';
  shell.dataset.density = density.value;
  density.addEventListener('change', () => { shell.dataset.density = density.value; write('dcms.ui.density', density.value); });
  document.querySelector('#libraryReset').addEventListener('click', () => {
    state.librarySearch = ''; state.libraryFilter = 'all'; state.libraryKind = 'all'; state.libraryShare = 'all';
    document.querySelector('#librarySearch').value = '';
    document.querySelector('#libraryFilterSelect').value = 'all';
    document.querySelector('#libraryKindSelect').value = 'all';
    document.querySelector('#libraryShareSelect').value = 'all';
    renderList(); document.querySelector('#librarySearch').focus();
  });
  document.querySelector('#libraryShareSelect').addEventListener('change', event => { state.libraryShare = event.target.value; renderList(); });
  const menus = [...document.querySelectorAll('.library-more, .library-columns')];
  document.addEventListener('click', event => {
    for (const menu of menus) if (!menu.contains(event.target) || event.target.closest('button')) menu.open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menus.some(menu => menu.open)) {
      for (const menu of menus) if (menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
      event.stopImmediatePropagation();
    }
  }, true);
}
